/**
 * The Omarti mark: a calm house with a smile.
 * Inlined as SVG so it renders instantly and can be tinted per surface.
 *
 * `tone` picks the stroke treatment:
 *  - "brand"  full navy -> indigo -> mauve -> rose gradient (light surfaces)
 *  - "light"  soft rose, for the navy sidebar and dark bars
 */
export function LogoMark({
  size = 34,
  tone = 'brand',
  title,
}: {
  size?: number;
  tone?: 'brand' | 'light';
  title?: string;
}) {
  const gradientId = `omaraty-mark-${tone}`;

  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          {tone === 'brand' ? (
            <>
              <stop offset="0%" stopColor="#27306B" />
              <stop offset="42%" stopColor="#5A50C8" />
              <stop offset="78%" stopColor="#8E7CD8" />
              <stop offset="100%" stopColor="#D98BA0" />
            </>
          ) : (
            <>
              <stop offset="0%" stopColor="#F5DDE3" />
              <stop offset="55%" stopColor="#C9BEF2" />
              <stop offset="100%" stopColor="#A79BEA" />
            </>
          )}
        </linearGradient>
      </defs>
      <path
        d="M18 54 L60 20 L102 54 V96 a6 6 0 0 1-6 6 H24 a6 6 0 0 1-6-6 Z"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth={9}
        strokeLinejoin="round"
      />
      <path
        d="M40 68 q20 22 40 0"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth={9}
        strokeLinecap="round"
      />
    </svg>
  );
}
